"use client";

const styles = new Proxy({"Team":"Team-97dfa"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

import Section from "../Section";

function Team({ block }: TeamProps) {
  const { title } = block;
  return (
    <Section
      title={title || "Meet The Team"}
      className={styles.Team}
      maxWidth={1080}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6">
            <img src="/images/MotionAnalysis/gergely.jpg" alt="Member" />
            <h4>
              <span>Gergely</span> Hanczár, PhD
            </h4>
            <p>Founder & CEO</p>
          </div>
          <div className="col-lg-4 col-md-6">
            <img src="/images/MotionAnalysis/bence.jpg" alt="Member" />
            <h4>
              <span>Bence</span> Borély, PhD
            </h4>
            <p>Lead AI Engineer</p>
          </div>
          <div className="col-lg-4 col-md-6">
            <img src="/images/MotionAnalysis/agnes.jpg" alt="Member" />
            <h4>
              <span>Ágnes</span> Chripkó, PhD
            </h4>
            <p>Data Ninja</p>
          </div>
          <div className="col-lg-4 col-md-6">
            <img src="/images/MotionAnalysis/mate.jpg" alt="Member" />
            <h4>
              <span>Máté</span> Palicz
            </h4>
            <p>Business Developer</p>
          </div>
          <div className="col-lg-4 col-md-6">
            <img src="/images/MotionAnalysis/oliver.jpg" alt="Member" />
            <h4>
              <span>Olivér</span> Törteli
            </h4>
            <p>CTO</p>
          </div>
          <div className="col-lg-4 col-md-6">
            <img src="/images/MotionAnalysis/nora.jpg" alt="Member" />
            <h4>
              <span>Nóra</span> Ovád
            </h4>
            <p>Junior Data Engineer</p>
          </div>
        </div>
      </div>
    </Section>
  );
}

export default Team;

interface TeamProps {
  block: {
    title?: string;
  };
}
